export const enum CountryCode {
    DK = 'DK',
    FI = 'FI',
    NO = 'NO',
    SE = 'SE',
    Unknown = 'Unknown',
}

export const toCountryCode = (countryCode: string): CountryCode => {
    if (countryCode && countryCode.toUpperCase() === 'DK') {
        return CountryCode.DK;
    }
    if (countryCode && countryCode.toUpperCase() === 'FI') {
        return CountryCode.FI;
    }
    if (countryCode && countryCode.toUpperCase() === 'NO') {
        return CountryCode.NO;
    }
    if (countryCode && countryCode.toUpperCase() === 'SE') {
        return CountryCode.SE;
    }
    return CountryCode.Unknown;
};
